<template>
  <Legenda titulo="Atualizar carrinho" legenda="Atualizar a quantidade e preço dos produtos no carrinho de compras">
    <v-btn
      v-show="GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO.length > 0"
      color="#042333"
      dark
      small
      @click="atualizarMultiplosItens()"
    >
      <v-icon size="20" class="mr-1">mdi-cart-arrow-right</v-icon>
      Atualizar Carrinho
      <span class="qtde-top-button-small">{{GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO.length}}</span>
    </v-btn>
  </Legenda>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { atualizarMultiplasQuantidadePrecoCarrinho } from "../CotacaoApi";
import Legenda from "@/components/produto/detalhes/Legenda";

export default {
  components: {
    Legenda
  },
  computed: {
    ...mapGetters({
      GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO"
    })
  },
  methods: {
    ...mapMutations({
      SET_ATUALIZAR_CARRINHO_COMPRAS: "CotacaoCarrinhoCompra/SET_ATUALIZAR_CARRINHO_COMPRAS",
      SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO"
    }),
    atualizarMultiplosItens() {
      this.$store.dispatch(
        "loading/addRequisicao",
        atualizarMultiplasQuantidadePrecoCarrinho(this.GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO)
          .then(() => {
            this.SET_ATUALIZAR_CARRINHO_COMPRAS()
            this.SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO([]);
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
